import { store } from "../../redux/store";
import { apiPost } from "../api";
import { refreshStoreTokens } from "../../redux/storeSlice";
import { getdeviceId } from "../auth";

/**
 * تقوم بطلب accessToken جديد باستخدام refreshToken
 * @returns accessToken الجديد أو null إذا فشل
 */
export const refreshAccessTokenStore = async (): Promise<string | null> => {
  const state = store.getState();
  const refreshToken = state.store.refreshToken;
  const deviceId = getdeviceId();

  if (!refreshToken) return null;

  try {
    // استدعاء API لتحديث accessToken
    const response = (await apiPost("store/refresh-token", {
      refreshToken,
      deviceId,
    })) as { accessToken: string; refreshToken: string };

    console.log(response);
    // حفظ accessToken الجديد في Redux
    store.dispatch(
      refreshStoreTokens({
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
      })
    );

    return response.accessToken;
  } catch (err) {
    console.error("Failed to refresh access token", err);
    // store.dispatch(logoutOwner()); // إذا انتهت صلاحية refreshToken → logout
    return null;
  }
};
